import { Component, inject } from '@angular/core';
import { MatButton } from '@angular/material/button';
import {
  MAT_DIALOG_DATA,
  MatDialogActions,
  MatDialogContent,
  MatDialogRef,
  MatDialogTitle,
} from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { SiaTranslatePipe } from '../../pipes/sia-translate.pipe';

@Component({
  selector: 'perspective-production-level-dialog',
  standalone: true,
  imports: [
    MatButton,
    MatDialogTitle,
    MatDialogActions,
    MatIconModule,
    MatDialogContent,
    SiaTranslatePipe,
  ],
  templateUrl: './perspective-production-level-dialog.component.html',
  styleUrl: './perspective-production-level-dialog.component.scss',
})
export class PerspectiveProductionLevelDialogComponent {
  data = inject(MAT_DIALOG_DATA);
  dialogRef =
    inject<MatDialogRef<PerspectiveProductionLevelDialogComponent>>(
      MatDialogRef,
    );
  originalType: string | undefined;

  /** Inserted by Angular inject() migration for backwards compatibility */

  constructor() {
    this.dialogRef.disableClose = false;
  }

  save() {
    this.dialogRef.close(this.data.configuration);
  }
}
